export default "__VITE_ASSET__DASfWixp__"